import { selectAuth } from '@brands/store/selectors/auth';
import { selectPatientMyProfile } from '@brands/store/selectors/patientMyProfile';
import React, { useState } from 'react';

import Container from '../../Components/Container/Container';
import { Loading } from '../../Components/LoadingSpinner/Loading';
import { useAppDispatch, useAppSelector } from '../../hooks/useReduxHook';
import { MyProfileSubmit } from '../MyProfile/Patient/utils/types';


const Pharmacy = (): JSX.Element => {
  const values = useAppSelector(selectPatientMyProfile);
  const dispatch = useAppDispatch();
  const { userInfo } = useAppSelector(selectAuth);
  const [render, setRender] = useState(false);
  if (render) {
    return (
      <Container containerStyle={{ overflow: 'hidden' }}>

      </Container>
    );
  }
  return <Loading fullScreen />;
};

export default Pharmacy;
